import React from 'react';
import { useTranslation } from 'react-i18next';
import { ClickAwayListener, MenuItem, MenuList, Popper } from '@mui/material';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectPlacementMarginOrderIdModifiedConfirmationStatus,
  selectSelectedPlacementMarginScenario,
} from 'store/redux-store/margin-tool/slices/placement/placement-add-edit-scenario/add-edit-placement-scenario.selector';
import { PlacementMarginPayPackageStatus } from 'store/redux-store/margin-tool/slices/placement/placement-pay-package-status/placement-pay-package-status.model';
import { placementMarginScenarioActions } from 'store/redux-store/margin-tool/slices/placement/placement-add-edit-scenario/add-edit-placement-scenario.redux';

export const MoreActionMenu = ({ classes, anchorEl, setAnchorEl, setDeleteConfirmOpen }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedScenario = useSelector(selectSelectedPlacementMarginScenario);
  const orderIdModifiedConfirmationStatus = useSelector(selectPlacementMarginOrderIdModifiedConfirmationStatus);
  //const [, setIsModalOpen] = useContext(ModalStatusContext);
  const isScenarioStatusPending = selectedScenario?.scenarioStatusId === PlacementMarginPayPackageStatus.Pending;

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  return (
    <Popper
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      role={undefined}
      style={{ zIndex: '999' }}
      className={classes.menu}
      placement={'bottom-end'}
    >
      <ClickAwayListener onClickAway={() => handleMenuClose()}>
        <MenuList>
          <MenuItem
            className={`${classes.menuItem} ${!isScenarioStatusPending ? classes.disabledButton : ''}`}
            onClick={e => {
              if (orderIdModifiedConfirmationStatus) {
                dispatch(placementMarginScenarioActions.setPlacementMarginShowOrderIdModifiedDialogStatus(true));
              } else {
                dispatch(placementMarginScenarioActions.openPlacementMarginToolEditDetails());
                //setIsModalOpen(true, PayPackageOptions.editScenario);
              }
              handleMenuClose();
            }}
          >
            <EditOutlinedIcon />
            {t('marginTool.scenarioNavigationTree.moreMenu.edit')}
          </MenuItem>
          <MenuItem
            className={`${classes.menuItem} ${
              selectedScenario?.isMostRecentBookingPeriod && isScenarioStatusPending ? '' : classes.disabledButton
            }`}
            onClick={e => {
              if (orderIdModifiedConfirmationStatus) {
                dispatch(placementMarginScenarioActions.setPlacementMarginShowOrderIdModifiedDialogStatus(true));
              } else {
                setDeleteConfirmOpen(true);
              }
              handleMenuClose();
            }}
          >
            <DeleteOutlinedIcon />
            {t('marginTool.scenarioNavigationTree.moreMenu.delete')}
          </MenuItem>
        </MenuList>
      </ClickAwayListener>
    </Popper>
  );
};
